export const VIP_COLORS = {
  primary: '#0068ef',
  secondary: '#FFF100',
  member: '#004499',
  blue: '#1484ff',
  gold: '#827643',
  platinum: '#2B2B2B',
  materialBg: '#001833',
}

const COLOR_VARIATIONS = {
  vip: {
    primaryColor: VIP_COLORS.primary,
    secondaryColor: VIP_COLORS.secondary,
  },
  dark: {
    primaryColor: VIP_COLORS.materialBg,
    secondaryColor: VIP_COLORS.secondary,
  },
}

export const getVariationColors = (variation) => COLOR_VARIATIONS[variation] || COLOR_VARIATIONS.vip
